module.exports = __webpack_public_path__ + "img/mainSprite.5361dee1.png";